import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import websocketService from '../services/websocketService';
import { emitSubscriptionRequired } from '../utils/subscriptionEvents';
import logger from '../utils/logger';

// Listens for backend push subscription status updates and emits unified subscription-required events
export default function SubscriptionStatusListener() {
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated || !user) return;
    let subscription;
    // Only baristas need real-time auto-logout push; owners already blocked at action time.
    if (user.role === 'BARISTA' && user.baristaShop) {
      const shopId = user.baristaShop.id;
      const destination = `/topic/shop/${shopId}/subscription-status`;
      subscription = websocketService.subscribe(destination, (payload) => {
        try {
          logger.debug('Subscription status push received', payload);
          if (payload && (payload.status === 'EXPIRED' || payload.status === 'NONE' || payload.status === 'TRIAL_EXPIRED')) {
            emitSubscriptionRequired({
              subscriptionStatus: payload.status,
              expiryDate: payload.expiresAt,
              message: 'Subscription status changed: ' + payload.status,
              force: true
            });
          }
        } catch (e) {
          logger.error('Error handling subscription status payload', e);
        }
      });
    }
    return () => {
      if (subscription) {
        websocketService.unsubscribe(subscription.id);
      }
    };
  }, [isAuthenticated, user]);

  return null;
}
